export default __webpack_public_path__ + "static/media/icon_image_gallery.220b0175.svg";